import type { IColors, ITypography } from "@swiggy-private/dls-web-common/dist/components/types.internal";

import type { OrderTypePreferenceOption } from "./types";

export const ORDER_PREFERENCE = {
    DELIVER_TO_SEAT: "DELIVER_TO_SEAT",
    PICKUP_AT_COUNTER: "PICKUP_AT_COUNTER",
} as const;

export const ON_PREMISE_SCREEN_SEAT_MAX_CHARS = 20;

export const ORDER_TYPE_BOTTOM_SHEET_COPY = {
    TITLE: "Order Type",
    SUBTITLE: "Get it delivered to your seat or Pick up at counter",
    DELIVER_TITLE: "Deliver to seat",
    DELIVER_DESC: "Add screen and seat info to deliver your order",
    PICKUP_TITLE: "Pick up at counter",
    PICKUP_DESC: "Order now and pick up with code",
    SCREEN_LABEL: "Screen",
    SCREEN_PLACEHOLDER: "Audi A, B, C ...",
    SEAT_LABEL: "Seat No.",
    SEAT_PLACEHOLDER: "A1, A2, A3 ...",
    MOBILE_LABEL: "Mobile number",
    CONFIRM: "Confirm",
} as const;

export const ORDER_TYPE_OPTIONS: OrderTypePreferenceOption[] = [
    {
        option: ORDER_PREFERENCE.DELIVER_TO_SEAT,
        label: ORDER_TYPE_BOTTOM_SHEET_COPY.DELIVER_TITLE,
        description: ORDER_TYPE_BOTTOM_SHEET_COPY.DELIVER_DESC,
        id: "on-premise-order-deliver",
        color: "primary",
    },
    {
        option: ORDER_PREFERENCE.PICKUP_AT_COUNTER,
        label: ORDER_TYPE_BOTTOM_SHEET_COPY.PICKUP_TITLE,
        description: ORDER_TYPE_BOTTOM_SHEET_COPY.PICKUP_DESC,
        id: "on-premise-order-pickup",
    },
];

export const getOrderTypePreferenceOptionStyles = (selected: boolean) => ({
    headingVariant: (selected ? "V2.body1.neutral.medium" : "V2.body1.neutral.regular") as keyof ITypography,
    headingColor: (selected ? "text_Highest_Emphasis" : "text_Med_Emphasis") as keyof IColors,
    subHeadingVariant: "V2.body3.neutral.regular" as keyof ITypography,
    subHeadingColor: "text_Low_Emphasis" as keyof IColors,
});
